import { render } from "./ZutatenAnzeigenView.vue?vue&type=template&id=aa821e98&scoped=true"
import script from "./ZutatenAnzeigenView.vue?vue&type=script&lang=js"
export * from "./ZutatenAnzeigenView.vue?vue&type=script&lang=js"

import "./ZutatenAnzeigenView.vue?vue&type=style&index=0&id=aa821e98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa821e98"]])

export default __exports__